import { Component, OnInit } from '@angular/core';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Usuario } from '../../../_model/Usuario';

@Component({
  selector: 'app-material-pendiente-apoyo',
  templateUrl: './material-pendiente-apoyo.component.html',
  styleUrls: ['./material-pendiente-apoyo.component.scss']
})
export class MaterialPendienteApoyoComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();

  public usuario: Usuario = new Usuario();

  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;

  // Variables
  ordenTrabajoId;
  materialesObtenidos;
 
  // array´s
  arrayMaterialSolicitado = [];

  constructor(
    private network: NetworkHelperService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.CODFUNC = CODFUNC;
    this.GENERALES = GENERALES;
    this.ordenTrabajoId = this.activatedRoute.snapshot.paramMap.get('idOrden');
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
  }

  ngOnInit() {
    this.materialesApoyar();
  }

  materialesApoyar () {
    const JSONAPOYOS = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.apoyos + '/' + this.API.user.listar + '/' + this.API.user.material + '/' + this.API.user.solicitado,
      'POST',
      JSONAPOYOS
    ).subscribe((response: any) => {
      console.log( response );
      this.materialesObtenidos = response.Mensaje;
      this.dtTrigger.next();
    }, err => {
      console.log( err );
    });
  }

  agregarMaterial (producto) {
    const buscandoMaterial = this.arrayMaterialSolicitado.find( productoEncontrado => productoEncontrado.codigo == producto.codigo );
    // console.log( buscandoMaterial );
    if ( !buscandoMaterial ) {
    // Condición para no agregar vacíos a tabla de solicitud respuesta
    if ( producto.cantidadApoyoSucursal ) {
      // El siguiente control, es para limitar el ingreso de cantidades.
      // No se puede agregar más de lo que te están solicitando en el apoyo.
      if ( producto.cantidadApoyoSucursal > producto.cantidad ) {
        Swal( 'Incorrecto', 'No puede ingresar más cantidad de la que te están solicitando', 'warning');
      } else {
        document.getElementById('materialesEnviar').style.display = 'block';
        document.getElementById('btnResponderSolicitud').style.display = 'block';
        this.arrayMaterialSolicitado.push({
          codigo: producto.codigo,
          descripcion: producto.descripcion,
          cantidadApoyo: Number(producto.cantidadApoyoSucursal),
          materialOrdenId: producto.materialOrdenId
        });
        // this.dtTrigger2.next();
      }
    } else {
      Swal( 'Atención', '¿Por qué no ingresaste ninguna cantidad?', 'question' );
    }
  } else {
    Swal('Incorrecto', 'El producto ya existe', 'warning');
  }

  }

  enviarRespuesta() {
    const JSONRespuestaSolicitud = {
      arrayMaterial: this.arrayMaterialSolicitado
    };

    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.apoyos + '/' + this.API.user.listar + '/' + this.API.user.material + '/' + this.API.user.enviado,
      'POST',
      JSONRespuestaSolicitud
    ).subscribe((response: any) => {
      console.log( response );
      Swal( 'Correcto', response.Mensaje , 'success');
    }, err => {
      console.log(err);
    });
  }

  eliminarMaterial(producto) {
    const nombreProducto = this.arrayMaterialSolicitado.find( productoEncontrado => productoEncontrado.codigo == producto.codigo );
    this.arrayMaterialSolicitado.splice(nombreProducto, 1);
  }

  negarApoyo ( producto ) {
    // Consulta para setear el campo autorizado y cantidadSucursal de la base.
    const JSONELIM = {
      sucursalId: this.usuario.sucId,
      ordenMaterialId : producto.materialOrdenId
    };
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.rechazar + '/' + this.API.user.sucursal,
      'POST',
      JSONELIM
    ).subscribe((response: any) => {
      console.log( response );
      Swal( 'Correcto', response.Mensaje , 'success');
    }, err => {
      console.log(err);
    });
    // Eliminar del array
    const eliminarDeArrayMaterial = this.materialesObtenidos.find( productoEncontrado => productoEncontrado.codigo == producto.codigo );
    this.materialesObtenidos.splice(eliminarDeArrayMaterial, 1);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-pendiente-apoyo/material-pendiente-apoyo.component.ts